import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _classPrivateMethodGet(receiver, privateSet, fn) { if (!privateSet.has(receiver)) { throw new TypeError("attempted to get private field on non-instance"); } return fn; }

/*
 * Copyright 2020 New Relic Corporation. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
*/
import { eventListenerOpts } from '../../../common/event-listener/event-listener-opts';
import { InstrumentBase } from '../../utils/instrument-base';
import * as CONSTANTS from '../constants';
import { isBrowserScope } from '../../../common/constants/runtime';
import { now } from '../../../common/timing/now';
import { handle } from '../../../common/event-emitter/handle';
import { wrapJsonP } from '../../../common/wrap/wrap-jsonp';
import { wrapPromise } from '../../../common/wrap/wrap-promise';
import { wrapTimer } from '../../../common/wrap/wrap-timer';
import { wrapXhr } from '../../../common/wrap/wrap-xhr';
import { wrapFetch } from '../../../common/wrap/wrap-fetch';
import { wrapHistory } from '../../../common/wrap/wrap-history';
import { wrapMutation } from '../../../common/wrap/wrap-mutation';
var FEATURE_NAME = CONSTANTS.FEATURE_NAME,
    START = CONSTANTS.START,
    END = CONSTANTS.END,
    BODY = CONSTANTS.BODY,
    CB_END = CONSTANTS.CB_END,
    JS_TIME = CONSTANTS.JS_TIME,
    FETCH = CONSTANTS.FETCH,
    FN_START = CONSTANTS.FN_START,
    CB_START = CONSTANTS.CB_START,
    FN_END = CONSTANTS.FN_END;
/**
 * @deprecated This feature has been deprecated, in favor of `soft_navigations`, which is in limited preview. Consider using/importing `SoftNavigations` instead. To gain access to the limited preview, please see https://docs.newrelic.com/docs/browser/single-page-app-monitoring/get-started/browser-spa-v2/ for more information. This feature will be removed in a future release.
 */

var _abort = /*#__PURE__*/new WeakSet();

export var Instrument = /*#__PURE__*/function (_InstrumentBase) {
  _inherits(Instrument, _InstrumentBase);

  var _super = _createSuper(Instrument);

  function Instrument(agentRef) {
    var _this$removeOnAbort, _this$removeOnAbort2, _this$removeOnAbort3;

    var _this;

    var auto = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    _classCallCheck(this, Instrument);

    _this = _super.call(this, agentRef, FEATURE_NAME, auto);

    _abort.add(_assertThisInitialized(_this));

    if (!isBrowserScope) return _possibleConstructorReturn(_this); // SPA not supported outside web env

    try {
      _this.removeOnAbort = new AbortController();
    } catch (e) {}

    var depth = 0;
    var startHash;

    var tracerEE = _this.ee.get('tracer');

    var jsonpEE = wrapJsonP(_this.ee);
    var promiseEE = wrapPromise(_this.ee);
    var timerEE = wrapTimer(_this.ee);
    var xhrEE = wrapXhr(_this.ee);

    var eventsEE = _this.ee.get('events'); // wrapXhr will call wrapEvents


    var fetchEE = wrapFetch(_this.ee);
    var historyEE = wrapHistory(_this.ee);
    var mutationEE = wrapMutation(_this.ee);

    _this.ee.on(FN_START, startTimestamp);

    promiseEE.on(CB_START, startTimestamp);
    jsonpEE.on(CB_START, startTimestamp);

    _this.ee.on(FN_END, endTimestamp);

    promiseEE.on(CB_END, endTimestamp);
    jsonpEE.on(CB_END, endTimestamp);

    _this.ee.on('fn-err', function () {
      var _args$, _args$$__newrelic;

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      if (!((_args$ = args[2]) !== null && _args$ !== void 0 && (_args$$__newrelic = _args$.__newrelic) !== null && _args$$__newrelic !== void 0 && _args$$__newrelic[agentRef.agentIdentifier])) handle('function-err', [].concat(args), undefined, _this.featureName, _this.ee);
    });

    _this.ee.buffer([FN_START, FN_END, 'xhr-resolved'], _this.featureName);

    eventsEE.buffer([FN_START], _this.featureName);
    timerEE.buffer(['setTimeout' + END, 'clearTimeout' + START, FN_START], _this.featureName);
    xhrEE.buffer([FN_START, 'new-xhr', 'send-xhr' + START], _this.featureName);
    fetchEE.buffer([FETCH + START, FETCH + '-done', FETCH + BODY + START, FETCH + BODY + END], _this.featureName);
    historyEE.buffer(['newURL'], _this.featureName);
    mutationEE.buffer([FN_START], _this.featureName);
    promiseEE.buffer(['propagate', CB_START, CB_END, 'executor-err', 'resolve' + START], _this.featureName);
    tracerEE.buffer([FN_START, 'no-' + FN_START], _this.featureName);
    jsonpEE.buffer(['new-jsonp', 'cb-start', 'jsonp-error', 'jsonp-end'], _this.featureName);
    timestamp(fetchEE, FETCH + START);
    timestamp(fetchEE, FETCH + '-done');
    timestamp(jsonpEE, 'new-jsonp');
    timestamp(jsonpEE, 'jsonp-end');
    timestamp(jsonpEE, 'cb-start');
    historyEE.on('pushState-end', trackURLChange);
    historyEE.on('replaceState-end', trackURLChange);
    window.addEventListener('hashchange', trackURLChange, eventListenerOpts(true, (_this$removeOnAbort = _this.removeOnAbort) === null || _this$removeOnAbort === void 0 ? void 0 : _this$removeOnAbort.signal));
    window.addEventListener('load', trackURLChange, eventListenerOpts(true, (_this$removeOnAbort2 = _this.removeOnAbort) === null || _this$removeOnAbort2 === void 0 ? void 0 : _this$removeOnAbort2.signal));
    window.addEventListener('popstate', function () {
      trackURLChange(0, depth > 1);
    }, eventListenerOpts(true, (_this$removeOnAbort3 = _this.removeOnAbort) === null || _this$removeOnAbort3 === void 0 ? void 0 : _this$removeOnAbort3.signal));

    function trackURLChange(unusedArgs, hashChangedDuringCb) {
      historyEE.emit('newURL', ['' + window.location, hashChangedDuringCb]);
    }

    function startTimestamp() {
      depth++;
      startHash = window.location.hash;
      this[FN_START] = now();
    }

    function endTimestamp() {
      depth--;

      if (window.location.hash !== startHash) {
        trackURLChange(0, true);
      }

      var time = now();
      this[JS_TIME] = ~~this[JS_TIME] + time - this[FN_START];
      this[FN_END] = time;
    }

    function timestamp(ee, type) {
      ee.on(type, function () {
        this[type] = now();
      });
    }

    _this.abortHandler = _classPrivateMethodGet(_assertThisInitialized(_this), _abort, _abort2);

    _this.importAggregator(agentRef);

    return _this;
  }
  /** Restoration and resource release tasks to be done if SPA loader is being aborted. Unwind changes to globals and subscription to DOM events. */


  return _createClass(Instrument);
}(InstrumentBase);

function _abort2() {
  var _this$removeOnAbort4;

  (_this$removeOnAbort4 = this.removeOnAbort) === null || _this$removeOnAbort4 === void 0 ? void 0 : _this$removeOnAbort4.abort();
  this.abortHandler = undefined; // weakly allow this abort op to run only once
}

_defineProperty(Instrument, "featureName", FEATURE_NAME);

export var Spa = Instrument;